function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M256 256L44.522 382.141V129.859z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M256 256l211.478 126.141H44.522zm211.478-126.141L256 256 44.522 129.859z",
  fill: "#ffda44"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M467.478 129.859v252.282L256 256z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M256 95.722l3.316 10.203h10.728l-8.679 6.306 3.316 10.204-8.681-6.307-8.68 6.307 3.316-10.204-8.68-6.306h10.728zm-85.906 0l3.316 10.203h10.727l-8.678 6.306 3.316 10.204-8.681-6.307-8.679 6.307 3.315-10.204-8.68-6.306h10.728zm171.812 0l3.316 10.203h10.728l-8.679 6.306 3.315 10.204-8.68-6.307-8.679 6.307 3.316-10.204-8.68-6.306h10.727zM256 389.565l3.316 10.203h10.728l-8.679 6.307 3.316 10.203-8.681-6.306-8.68 6.306 3.316-10.203-8.68-6.307h10.728zm-85.906 0l3.316 10.203h10.727l-8.678 6.307 3.316 10.203-8.681-6.306-8.679 6.306 3.315-10.203-8.68-6.307h10.728zm171.812 0l3.316 10.203h10.728l-8.679 6.307 3.315 10.203-8.68-6.306-8.679 6.306 3.316-10.203-8.68-6.307h10.727z",
  fill: "#ffda44"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 37.988,
  fill: "#a2001d"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M256 218.008l8.516 26.21h27.561l-22.296 16.202 8.515 26.211L256 270.432l-22.298 16.199 8.517-26.211-22.296-16.202h27.56zm-148.345 35.173c4.383 6.926 2.323 16.092-4.602 20.477s-16.092 2.324-20.477-4.602c-7.937-12.54-3.335-33.016-3.335-33.016s20.475 4.602 28.414 17.141z",
  fill: "#ffda44"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 99.083,
  cy: 267.386,
  r: 7.42,
  fill: "#a2001d"
});

const SvgGrenada = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGrenada, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grenada.0c37d68f.svg";
export { ForwardRef as ReactComponent };